import React, { useEffect, useState } from "react"; 
import { Header } from "../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../components/SpearParts/Layouts/SeachSection";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { searchPart, getCompleteData, getItems } from "../../actions/HomeAction";
import NoData from "../../components/NoData/Index";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import Axios from "../../axios/axios";

export default function SubCategory() {

  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const [parts, setParts] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareModels, setSpareModels] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);

  // 🔹 The ONLY change: we use subcategories from location.state
  const [subcategories, setSubcategories] = useState(
    location.state?.subcategories || []
  );

 const filters = {
  brandId: searchParams.get("brandId") || location.state?.filters?.brandId || "",
  modelId: searchParams.get("modelId") || location.state?.filters?.modelId || "",
  year: searchParams.get("year") || location.state?.filters?.year || "",
  regionId: searchParams.get("regionId") || location.state?.filters?.regionId || "",
};

  useEffect(() => {
    if (location.state) {
      setSpareCategory(location.state.spareCategory || []);
      setSpareBrand(location.state.spareBrand || []);
      setSpareModels(location.state.spareModels || []);
      setRegion(location.state.region || []);
      setYears(location.state.years || []);
      setSubcategories(location.state.subcategories || []);
    } else {
      getCompleteData(setSpareModels, setSpareBrand, setSpareCategory);
      getItems(setRegion);
    }
  }, [location.state]);
  
// 🔹 Fetch filtered subcategories based on URL filter values (for refresh & shareable URL)
useEffect(() => {
  const fetchFilteredSubcategories = async () => {
    try {
      const res = await Axios.get("/parts/search", { params: { ...filters } });

      const categoryId = searchParams.get("categoryId");
      const matchedCategory = res.data.categories?.find(
        (c) => c._id === categoryId
      );

      setSubcategories(matchedCategory?.subcategories || []);
    } catch (error) {
      console.error("Error fetching filtered subcategories:", error);
    }
  };

  fetchFilteredSubcategories();
}, [location.search]);

  const [page, setPage] = useState(1);
  const [totalPages] = useState(1); // No API pagination needed since subcategory list is static

  // 🔹 New card component displaying SUBCATEGORIES instead of CATEGORIES
  const SubCategoryCard = ({ sub }) => {

const handleClick = () => {
  const query = new URLSearchParams({
    subcategoryId: sub._id,
    brandId: filters.brandId || "",
    modelId: filters.modelId || "",
    year: filters.year || "",
    regionId: filters.regionId || ""
  }).toString();

  navigate(`/productlist?${query}`, {
    state: {
      spareCategory,
      spareBrand,
      spareModels,
      region,
      years,
      filters
    }
  });
};


    return (
      <div className="category-item" onClick={handleClick} style={{ cursor: "pointer" }}>
        <div className="d-flex flex-column align-items-center">
          {sub.image && <img src={sub.image} alt={sub.name} />}
          <h6>{sub.name}</h6>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Header />

      <section id="inner-banner">
        <div className="container">

          {/* 🔹 Same Search Section */}
          <SeachSection initialFilters={filters} />
          <div className="category-single-page-container" style={{ width: "85%", margin: "auto" }}>

          <button
            className="back btn btn-light mt-3"
            style={{ backgroundColor: "#dbe4f0ff" }}
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-long-arrow-left"></i> Back
          </button>

          <div className="category-grid mt-4">
            {subcategories.length > 0 ? (
              subcategories.map((sub, idx) => <SubCategoryCard key={idx} sub={sub} />)
            ) : (
              <NoData />
            )}
          </div>
</div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
